import { render, staticRenderFns } from "./browse-genres.vue?vue&type=template&id=16e586fe&scoped=true"
import script from "./browse-genres.vue?vue&type=script&setup=true&lang=js"
export * from "./browse-genres.vue?vue&type=script&setup=true&lang=js"
import style0 from "./browse-genres.vue?vue&type=style&index=0&id=16e586fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e586fe",
  null
  
)

export default component.exports